import React from "react";
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Home from "@/pages/Home/Home";

const BasicRoute = () => (
  <Router>
    <Switch>
      <Route exact path="/index" component={Home} />
      <Redirect from="/" exact to="/index" />
    </Switch>
  </Router>
);

export default BasicRoute;
